export default {
  HAS_DUE_ABOVE_A_MONTH: "__has_due_above_a_month__",
};
